import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useServiceLogos } from '@hooks/use-service-logos'
import { parseMarginOrPadding } from '@helpers'

const StyledServiceLogo = styled.div`
  display: flex;
  ${({ size }) => {
    if (size === 2) {
      return `
        min-width: 64px;
        min-height: 64px;
      `
    } else if (size === 1) {
      return `
        min-width: 30px;
        min-height: 30px;
      `
    } else {
      return `
        min-width: 125px;
        min-height: 125px;
      `
    }
  }}
  background : ${(props) => props.background || 'none'};
  border-radius: 100%;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: ${({ margin }) => parseMarginOrPadding(margin)};

  ::after {
    content: ${(props) => `"${props.text}"`};
    position: absolute;
    font-size: 40px;
    left: calc(100% + 10px);
    top: 50%;
    transform: translateY(-50%);
  }
`

const StyledImg = styled.img`
  width: ${({ size }) => size}rem;
  height: ${({ size }) => size}rem;
`

const findLogo = ({ logos, id = null, name = null }) => {
    const key = id || name
    const result = logos.find(({ node }) => {
      return node.name.toLowerCase() === key
    })
    const node = result ? result.node : false
    if (node && node.logo) {
      return {
        url: node.logo.cdn,
        name: node.name
      }
    } else {
      return { url: '', name: 'File does not exist' }
    }
  }

const ServiceLogo = ({
  logo = null,
  id = null,
  text = false,
  lg,
  sm,
  xs,
  bg,
  src = null,
  ...rest
}) => {
  const logos = useServiceLogos()

  let size
  if (lg) size = 4
  else if (sm) size = 2
  else if (xs) size = 1
  else size = 4

  // const ServiceLogo = src
  //   ? { url: src, name: '' }
  //   : find({ id, name: logo.toLowerCase() })
  // if (!ServiceLogo)
  //   throw new Error(`Cannot find ServiceLogo: id: ${id} name: ${logo}`)
  const ServiceLogo = src
     ? { url: src, name: '' }
     : findLogo({ logos, id, name: logo.toLowerCase() })
  return (
    <StyledServiceLogo
      size={size}
      text={text ? ServiceLogo.name : ''}
      background = {bg}
      {...rest}
    >
      <StyledImg size={size} src={ServiceLogo.url} alt={ServiceLogo.name || "Service-logo"}/>
    </StyledServiceLogo>
  )
}

ServiceLogo.propTypes = {
  customData: PropTypes.string,
  logo: PropTypes.string,
  id: PropTypes.string,
  text: PropTypes.string,
  lg: PropTypes.any,
  sm: PropTypes.any,
  xs: PropTypes.any,
  bg: PropTypes.any,
  src: PropTypes.string
}

export default ServiceLogo
